import { useConfig } from 'src/app/shared/hooks/useConfig';
import { useHirerAccount } from 'src/app/v2/hooks/useHirerAccount';
import { useGetLocationLazyQuery } from 'src/graphql/generated';

export const useLocationLazyQuery = (locationId: string) => {
  const hirerAccount = useHirerAccount();
  const { getLanguage } = useConfig();

  const [getLocationQuery] = useGetLocationLazyQuery({
    variables: {
      locationId,
      contextualCountry: hirerAccount?.nation,
      language: getLanguage(),
    },
    fetchPolicy: 'cache-first',
  });

  return [getLocationQuery];
};
